import { render, staticRenderFns } from "./ShopLayout.vue?vue&type=template&id=96b4da24&"
import script from "./ShopLayout.vue?vue&type=script&lang=js&"
export * from "./ShopLayout.vue?vue&type=script&lang=js&"
import style0 from "./ShopLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b4da24')) {
      api.createRecord('96b4da24', component.options)
    } else {
      api.reload('96b4da24', component.options)
    }
    module.hot.accept("./ShopLayout.vue?vue&type=template&id=96b4da24&", function () {
      api.rerender('96b4da24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/ShopLayout.vue"
export default component.exports